import { useAuth0 } from "@auth0/auth0-react";
import { Box, CssBaseline } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";

import { Content, Footer, Navbar } from "@/components";
import { logoutHandler } from "@/utils";

const DriveManagementLayout = () => {
    const [open, setOpen] = useState(false);

    const location = useLocation();

    const { isAuthenticated, isLoading, logout } = useAuth0();

    useEffect(
        () => {
            if (!isLoading && !isAuthenticated) {
                logoutHandler(logout, location.pathname);
            }
        },
        [isAuthenticated, isLoading], // eslint-disable-line
    );

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                }}
            >
                <CssBaseline />
                <Navbar open={open} isDriveManagementNavbar onOpenSidebar={() => setOpen(true)} />
                <Content open={open}>
                    <Outlet />
                </Content>
            </Box>
            <Footer />
        </>
    );
};

export default DriveManagementLayout;
